import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public exists(key: string) {
    return key in window.localStorage;
  }

  public get<T>(key: string): T | null {
    return this.exists(key) ? (JSON.parse(window.localStorage.getItem(key)) as T) : null;
  }

  public set<T>(key: string, value: T) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (quoteExceededError) {
      const errorMessage = `Error when caching value for key "${key}" in local storage.`;
      Sentry.captureMessage(errorMessage);
      console.warn(errorMessage, quoteExceededError);
      this.delete(key); // Prevents application getting into invalid state.
    }
  }

  public delete(key: string) {
    window.localStorage.removeItem(key);
  }

  public deleteAllWithPrefix(prefix: string) {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(prefix))
      .forEach((key) => this.delete(key));
  }

  clear() {
    window.localStorage.clear();
  }
}
